export const filterConfig = [
  {
    id: 'nomeTag',
    type: 'text',
    label: 'Nome da Tag',
    placeholder: 'Digite o nome da tag',
  },
  {
    id: 'descricao',
    type: 'text',
    label: 'Descricao',
    placeholder: 'Digite parte da descricao',
  },
  {
    id: 'dataCriacaoInicial',
    type: 'date',
    label: 'Data Inicial',
  },
  {
    id: 'dataCriacaoFinal',
    type: 'date',
    label: 'Data Final',
  },
];
